module.exports = __webpack_public_path__ + "img/street-food.c444de4e.svg";